import { Transform, Type } from "class-transformer";
import Position from "./portfolioPosition";

export default class RebalanceItem {

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  updatedAt: Date;

  /** Position of this rebalance item. */
  @Type(() => Position)
  position: Position;

  /**
   * @param id GUID of this rebalance item.
   * @param rebalancePlanId ID of the rebalance plan to which this item belongs to.
   * @param position Position of this rebalance item.
   * @param quantity Quantity of the security hold by this rebalance item.
   * @param price Price at which this rebalance item is being valued.
   * @param done Indicates if the necessary rebalance of this item has already been done, serving as todo check item.
   * @param updatedAt When was the last time this rebalance plan was updated.
   */
  constructor(
    public id: string | undefined,
    public rebalancePlanId: string,
    public quantity: number,
    public price: number,
    public done: boolean,
    updatedAt: Date,
    position: Position,
  ) {
    this.position = position;
    this.updatedAt = updatedAt;
  }

  notional(): number {
    return this.quantity * this.price;
  }

}